export default __webpack_public_path__ + "61a2e51212ee0deb98c0291f5e68adfe.svg";